import React from 'react';
import { Link } from 'react-router-dom';
import { qualityChecks } from '../../mock/content';
import { Check, ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { track, events } from '../../lib/analytics';

const Quality = () => {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            The quality standard
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Nothing reaches your client unverified
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            Every lead is validated against your agreed specification before delivery. Contact data verified, titles and targeting checked, suppression lists honoured. Anything that fails is replaced automatically. Your name goes on every lead — our standard is simple: we would rather deliver late than deliver wrong. (We do neither.)
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {qualityChecks.map((c, i) => (
            <Reveal
              key={c}
              delay={i * 90}
              className="flex items-center gap-3 rounded-2xl bg-white shadow-mk px-5 py-5 hover:shadow-mk-lg hover:-translate-y-1 transition-all duration-300"
            >
              <span className="h-9 w-9 rounded-xl bg-gradient-to-br from-brand-blue to-brand-blue-light text-white flex items-center justify-center shrink-0 shadow-mk-blue">
                <Check size={16} strokeWidth={3} />
              </span>
              <span className="text-navy text-[14px] font-bold">{c}</span>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/contact"
            data-testid="quality-grab-15-btn"
            onClick={() => track(events.GRAB_15_CALL_CLICK, { location: 'quality' })}
            className="inline-flex items-center gap-2 text-brand-blue text-[13px] font-bold uppercase tracking-[0.08em] hover:gap-3 transition-all duration-300"
          >
            Grab a 15-minute call
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Quality;
